var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center m-2"},[_c('img',{staticClass:"mr-2 mt-6 h-16 cursor-pointer",attrs:{"src":require("@/assets/images/logo/logo.svg")},on:{"click":_vm.navigateTohome}})]),_c('LoginModes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }